import React from 'react'

function LatestProperties() {
  return (
    <section class="lifestyle-explore-main container mt-5 mb-5">
    <div class="lifestyle-text mb-4">
      <h5 class="fw-bold mb-5">Latest Properties</h5>
    </div>
    <div class="lifestyle-content row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-md-3 justify-content-between pb-4 mt-4 gy-4">
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd text-center">
          <img
            class="img-fluid"
            style={{ height: "70px", width: "70px" }}
            src="./images/illustration/apartment2.png"
            alt=""
          />
          <h6 class="card-title lifestyle-crd-heading">Apartment</h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
            102 Properties
          </p>
          <a href="#" class="card-link btn exp-all text-white">
            Explore all <i class="bi bi-caret-right-fill"></i>
          </a>
        </div>
      </div>
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd text-center">
          <img
            class="img-fluid"
            style={{ height: "70px", width: "70px" }}
            src="./images/illustration/house.png "
            alt=""
          />
          <h6 class="card-title lifestyle-crd-heading">Homes</h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
            102 Properties
          </p>
          <a href="#" class="card-link btn exp-all text-white">
            Explore all <i class="bi bi-caret-right-fill"></i>
          </a>
        </div>
      </div>
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd text-center">
          <img
            class="img-fluid"
            style={{ height: "70px", width: "70px" }}
            src="./images/illustration/building1.png "
            alt=""
          />
          <h6 class="card-title lifestyle-crd-heading">Commercial</h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
            102 Properties
          </p>

          <a href="#" class="card-link btn exp-all text-white">
            Explore all <i class="bi bi-caret-right-fill"></i>
          </a>
        </div>
      </div>
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd text-center">
          <img
            class="img-fluid"
            style={{ height: "70px", width: "70px" }}
            src="./images/illustration/beach-house.png "
            alt=""
          />
          <h6 class="card-title lifestyle-crd-heading">Villas/Resorts</h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
            102 Properties
          </p>

          <a href="#" class="card-link btn exp-all text-white">
            Explore all <i class="bi bi-caret-right-fill"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  )
}

export default LatestProperties